import { render, staticRenderFns } from "./CandidateDashboard.vue?vue&type=template&id=5cd967a6&scoped=true"
import script from "./CandidateDashboard.vue?vue&type=script&lang=js"
export * from "./CandidateDashboard.vue?vue&type=script&lang=js"
import style0 from "./CandidateDashboard.vue?vue&type=style&index=0&id=5cd967a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd967a6",
  null
  
)

export default component.exports